import nacl from 'tweetnacl';
import bs58 from 'bs58';

const buildUrl = (path, params) => `https://phantom.app/ul/v1/${path}?${params.toString()}`;
const decryptPayload = (data, nonce, sharedSecret) => {
    const decryptedData = nacl.box.open.after(bs58.decode(data), bs58.decode(nonce), sharedSecret);
    if (!decryptedData) {
        throw new Error('Unable to decrypt data');
    }
    return JSON.parse(Buffer.from(decryptedData).toString('utf8'));
};
const encryptPayload = (payload, sharedSecret) => {
    const nonce = nacl.randomBytes(24);
    const encryptedPayload = nacl.box.after(Buffer.from(JSON.stringify(payload)), nonce, sharedSecret);
    return [nonce, encryptedPayload];
};

export { buildUrl, decryptPayload, encryptPayload };
